import React from "react";
import { type Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripePaymentIntentCompletedMessage from "./StripePaymentIntentCompletedMessage";
import Panel from "../../components/panels/panel";
import { useLoaderData } from "react-router";

interface StripeSetupIntentCompletePanelLoaderData {
  stripePromise: Promise<Stripe>;
  viewModel: server.viewmodel.SubscriptionPaymentSetupCompleteFrontModel;
}

const StripeSetupIntentCompletePanel = () => {
  const { viewModel, stripePromise } = useLoaderData<StripeSetupIntentCompletePanelLoaderData>();
  return (
    <Panel
      title={RESX.Payment.PaymentMethod}
      panelClassName="s1_related-feature-panel"
    >
      <div className="content-section">
        <Elements stripe={stripePromise}>
          <div className="margin-bottom-huge">
            <StripePaymentIntentCompletedMessage />
          </div>
          <div className="flex justify-end">
            <a href={viewModel.subscriptionPageUrl} className="button-new tertiary">{RESX.Buttons.BtnOk}</a>
          </div>
        </Elements>
      </div>
    </Panel >
  );
};

export default StripeSetupIntentCompletePanel;